import React from 'react';
import { Helmet } from 'react-helmet';
import styles from './AboutPage.module.css';

export const AboutPage = () => {
  return (
    <div className={styles.container}>
      <Helmet>
        <title>Enzo's Toolkit 소개</title>
        <meta name="description" content="투자를 좋아하는 프론트엔드 개발자 Enzo가 개인적인 필요와 호기심으로 만든 프로젝트들을 모아둔 공간입니다. 기술로 일상의 불편함을 해결하고 그 과정을 기록하며 즐거움을 찾습니다." />
      </Helmet>
      <h1>Enzo's Toolkit 소개</h1>
      <p>
        안녕하세요! 저는 투자를 좋아하는 프론트엔드 개발자입니다.
      </p>
      <p>
        Enzo's Toolkit은 저의 개인적인 필요와 호기심에서 시작된 프로젝트들을 한데 모아두는 공간입니다. 일상에서 마주하는 작은 불편함들을 기술의 힘으로 해결하고, 그 과정을 기록하며 새로운 즐거움을 찾아가는 저의 여정을 담고 있습니다. 이곳의 모든 도구와 콘텐츠는 이러한 철학을 바탕으로 만들어졌습니다.
      </p>
      <p>
        기술을 통해 삶을 더 편리하고 풍요롭게 만드는 것에 관심이 많습니다. 이 공간이 여러분에게도 작게나마 도움이 되거나 새로운 영감을 줄 수 있기를 바랍니다.
      </p>
      <p className={styles.contact}>
        연락처: <a href="mailto:contact@enzo2.life">contact@enzo2.life</a>
      </p>
    </div>
  );
};
